
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.004 1v1.02a8.21 8.21 0 00-2.824.808c-1.352.68-2.735 2.11-3.047 4.317-.73.136-1.356.386-1.703.87C6.95 8.688 7 9.388 7 9.728V12h2.004a7 7 0 003.09 5.797C8.52 19.324 6.004 22.875 6.004 27h2c0-2.238.91-4.254 2.387-5.703l2.398 3.047 3.215-2.14 3.277 2.183 2.168-3.246A7.964 7.964 0 0124.004 27h2c0-4.125-2.516-7.676-6.09-9.203A7.002 7.002 0 0023.004 12H25V9.727c.004-.254.14-.95-.328-1.672-.348-.532-1.008-.785-1.797-.918-.313-2.211-1.676-3.645-3.016-4.32a7.868 7.868 0 00-2.855-.805V1zm2 3.031a5.548 5.548 0 011.953.57c.879.446 1.676 1.087 1.945 2.399h-.898v2h2c.95 0 1.016.18.992.145-.027-.036.008.128.004.582V10H9v-.273c0-.364.043-.528.055-.543C9.066 9.168 9.16 9 10 9h2.004V7h-.895c.274-1.293 1.075-1.938 1.965-2.383a5.62 5.62 0 011.93-.574v2.02h2zm-6 7.969h10c0 2.773-2.227 5-5 5-2.774 0-5-2.227-5-5zm5 7c1.387 0 2.687.348 3.824.965l-1.101 1.648-2.723-1.816-2.785 1.86-1.235-1.571A7.955 7.955 0 0116.004 19z"}})])
          )
        }
      }
    